import * as d3 from 'd3'

export default {
  methods: {
    call_Link(selection, data) {
      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        window.open('http://localhost:8080/'+data.url, '_blank');
      })
    }, 
  }
}